import { render, staticRenderFns } from "./prewModal.vue?vue&type=template&id=326f7e3e&scoped=true"
import script from "./prewModal.vue?vue&type=script&lang=js"
export * from "./prewModal.vue?vue&type=script&lang=js"
import style0 from "./prewModal.vue?vue&type=style&index=0&id=326f7e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326f7e3e",
  null
  
)

export default component.exports